// /**
//  * Bundle - list
//  */

// React
import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import HeaderBuilder from '../../../utils/headerBuilder';
// Context
import AuthContext from '../../../authContext';

// UI
import theme from '../../../theme';
import {
  createStyles,
  makeStyles,
  Theme,
  withStyles,
} from '@material-ui/core/styles';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  Paper,
  IconButton,
  Badge,
} from '@material-ui/core';

// Icon
import Icon from '@mdi/react';
import {
  mdiFileDocumentOutline,
  mdiChevronDown,
  mdiChevronUp,
} from '@mdi/js';

// Helper
import { checkMatchMedia } from '../../../utils/helpers';

// Type
import { CenterStatistic } from '../../centers/interfaces';

type Data = CenterStatistic;
type Props = {
  data: any;
};

type Ord = 'asc' | 'desc';
interface HeadCell {
  id: keyof Data;
  label: string;
}
interface EnhancedTableProps {
  classes: ReturnType<typeof useStyles>;
  onRequestSort: (
    event: React.MouseEvent<unknown>,
    property: keyof Data
  ) => void;
  order: Ord;
  orderBy: string;
  rowCount: number;
}

// Style
const StyledBadge = withStyles((theme: Theme) =>
  createStyles({
    badge: {
      // right: -3,
      // top: 13,
      border: `2px solid ${theme.palette.background.paper}`,
      padding: '0 4px',
      fontSize: '14px',
    },
  })
)(Badge);
const StyledTableCell = withStyles((theme: Theme) =>
  createStyles({
    head: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.common.white,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      '@media (max-width: 768px)': {
        fontSize: 10,
      },
    },
    body: {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      fontSize: 14,
    },
  })
)(TableCell);

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
    },
    paper: {
      width: '100%',
    },
    table: {
      // minWidth: 750,
    },
    head: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.common.white,
    },
    visuallyHidden: {
      border: 0,
      clip: 'rect(0 0 0 0)',
      height: 1,
      margin: -1,
      overflow: 'hidden',
      padding: 0,
      position: 'absolute',
      top: 20,
      width: 1,
    },
    container: {
      maxHeight: 540,
      borderRadius: '4px',
    },
    // Fully visible for active icons
    activeSortIcon: {
      opacity: 1,
      color: `${theme.palette.secondary.main}!important`,
    },
    // Half visible for inactive icons
    inactiveSortIcon: {
      opacity: 0.4,
    },
    changStatusIcon: {
      marginRight: '10px',
      position: 'absolute',
    },
    changStatusBox: {
      display: 'flex',
      textAlign: 'left',

      fontWeight: 400,
      fontSize: '14px',
    },
    renderValue: {
      paddingLeft: '32px',
    },
    radioGroup: {
      margin: '-8px 0',
    },
    radioGroupItem: {
      borderBottom: '1px solid #D8D8D8',
      marginRight: '-8px',
      padding: '8px 16px',
      '&:last-child': {
        borderBottom: '0px',
      },
    },
  })
);

// const

const bundleStatus = [
  'CREATED',
  'ASSIGNED',
  'PROCESS_STARTED',
  'PROCESSED',
  'VEHICLE_ARRIVED',
  'LOADED',
  'PROCESSED',
  'PROCESS_FAILED',
  'CANCELLED',
];

function descendingComparator<T>(a: T, b: T, orderBy: keyof T) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator<Key extends keyof any>(
  order: Ord,
  orderBy: Key
): (
    a: { [key in Key]: number | string },
    b: { [key in Key]: number | string }
  ) => number {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort<T>(array: T[], comparator: (a: T, b: T) => number) {
  const stabilizedThis = array.map((el, index) => [el, index] as [T, number]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map(el => el[0]);
}

const headCells: HeadCell[] = [
  {
    id: 'name',
    label: 'نام مرکز',
  },
  { id: 'id', label: 'شناسه مرکز' },
  { id: 'beforeCount', label: 'روزهای گذشته' },
  { id: 'todayCount', label: 'امروز' },
  { id: 'tomorrowCount', label: 'فردا' },
  { id: 'afterTomorrowCount', label: 'پس فردا' },
  // {id: 'stockCount', label: 'موجودی'},
  // {id: 'stockCount', label: 'کسری'},
];

function EnhancedTableHead(props: EnhancedTableProps) {
  const { order, orderBy, onRequestSort } = props;
  const classes = useStyles();
  const createSortHandler =
    (property: keyof Data) => (event: React.MouseEvent<unknown>) => {
      onRequestSort(event, property);
    };

  return (
    <TableHead>
      <TableRow>
        {headCells.map(headCell => (
          <StyledTableCell
            key={headCell.id}
            align="center"
            sortDirection={orderBy === headCell.id ? order : false}
            data-cy={headCell.id}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
              IconComponent={() => (
                <Icon
                  path={
                    orderBy === headCell.id && order === 'desc'
                      ? mdiChevronDown
                      : mdiChevronUp
                  }
                  size={0.7}
                  className={
                    orderBy === headCell.id
                      ? classes.activeSortIcon
                      : classes.inactiveSortIcon
                  }
                />
              )}
            >
              {headCell.label}
            </TableSortLabel>
          </StyledTableCell>
        ))}
        <StyledTableCell />
      </TableRow>
    </TableHead>
  );
}

export default function EnhancedTable(props: Props) {
  const authContext = useContext(AuthContext);

  const classes = useStyles();
  const [order, setOrder] = React.useState<Ord>('desc');
  const [orderBy, setOrderBy] = React.useState<keyof Data>('id');
  // const [dense] = React.useState(false);

  const handleRequestSort = (
    event: React.MouseEvent<unknown>,
    property: keyof Data
  ) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  return (
    <div className={classes.root}>
      <TableContainer component={Paper}>
        <Table
          stickyHeader
          className={classes.table}
          aria-labelledby="tableTitle"
          size={checkMatchMedia('(max-width: 1024px)') ? 'small' : 'medium'}
          aria-label="enhanced table"
        >
          <HeaderBuilder
            order={order}
            orderBy={orderBy}
            onRequestSort={handleRequestSort}
            rowCount={props.data.length}
            filterVal={props.filterVal}
            onFilterValue={(filtervalues: any) => {
              props.onFilterValue(filtervalues);
            }}
            head={props.head}
            removeFilterHandler={props.removeFilterHandler}
            haveAction={true}
            filterLabelTranslator={props.filterLabelTranslator}
          />
          <TableBody>
            {stableSort(props.data, getComparator(order, orderBy))
              .slice()
              .map((row: any, index: number) => {
                const labelId = `enhanced-table-checkbox-${index}`;

                return (
                  <TableRow key={index}>
                    <StyledTableCell
                      component="th"
                      id={labelId}
                      scope="row"
                      align="center"
                    >
                      {row.name}
                    </StyledTableCell>
                    <StyledTableCell align="center">{row.id}</StyledTableCell>
                    <StyledTableCell align="center">
                      {row.beforeCount}
                    </StyledTableCell>{' '}
                    <StyledTableCell align="center">
                      {row.todayCount}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {row.tomorrowCount}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {row.afterTomorrowCount}
                    </StyledTableCell>
                    {/* <StyledTableCell align="center">
                      {row.stockCount}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {row.todayCount +
                        row.beforeCount +
                        row.tomorrowCount +
                        row.afterTomorrowCount -
                        row.stockCount}
                    </StyledTableCell> */}
                    <StyledTableCell align="center">
                      <Link
                        to={`/centersStatistics/details/${row.id}/${row.name}`}
                      >
                        <IconButton
                          aria-label="details"
                          size="small"
                          title="جزئیات سفارش‌های انبار"
                          data-cy="details"
                        >
                          <Icon
                            path={mdiFileDocumentOutline}
                            size={1}
                            color={theme.palette.green.main}
                          />
                        </IconButton>
                      </Link>
                    </StyledTableCell>
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}
